import { HammerGestureConfig } from '@angular/platform-browser';

export class HammerConfig extends HammerGestureConfig {
  // Fix scrolling for elements with swipe listener
  overrides = <any>{
    pinch: { enable: false },
    rotate: { enable: false },
  };
}
